import React from 'react';

// REAL fence icons that actually look like fences
// Each icon is designed to be instantly recognizable as that fence type

// Vinyl Privacy Fence - solid panels with decorative top
export const VinylFenceIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Left post */}
    <rect x="4" y="8" width="6" height="52" fill={color} rx="1"/>
    {/* Right post */}
    <rect x="54" y="8" width="6" height="52" fill={color} rx="1"/>
    {/* Top rail */}
    <rect x="4" y="12" width="56" height="4" fill={color}/>
    {/* Middle rail */}
    <rect x="4" y="32" width="56" height="3" fill={color}/>
    {/* Bottom rail */}
    <rect x="4" y="52" width="56" height="3" fill={color}/>
    {/* Vertical boards (privacy panels) */}
    <rect x="12" y="12" width="5" height="43" fill={color} opacity="0.85"/>
    <rect x="19" y="12" width="5" height="43" fill={color} opacity="0.85"/>
    <rect x="26" y="12" width="5" height="43" fill={color} opacity="0.85"/>
    <rect x="33" y="12" width="5" height="43" fill={color} opacity="0.85"/>
    <rect x="40" y="12" width="5" height="43" fill={color} opacity="0.85"/>
    <rect x="47" y="12" width="5" height="43" fill={color} opacity="0.85"/>
    {/* Post caps */}
    <rect x="2" y="4" width="10" height="4" fill={color} rx="1"/>
    <rect x="52" y="4" width="10" height="4" fill={color} rx="1"/>
  </svg>
);

// Wood Fence - classic board on board with visible wood grain texture
export const WoodFenceIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Posts */}
    <rect x="2" y="6" width="8" height="54" fill={color} rx="1"/>
    <rect x="54" y="6" width="8" height="54" fill={color} rx="1"/>
    {/* Horizontal rails */}
    <rect x="2" y="14" width="60" height="4" fill={color} opacity="0.9"/>
    <rect x="2" y="44" width="60" height="4" fill={color} opacity="0.9"/>
    {/* Vertical boards with pointed tops */}
    <path d="M14 8L17 4L20 8V52H14V8Z" fill={color} opacity="0.8"/>
    <path d="M22 8L25 4L28 8V52H22V8Z" fill={color} opacity="0.85"/>
    <path d="M30 8L33 4L36 8V52H30V8Z" fill={color} opacity="0.8"/>
    <path d="M38 8L41 4L44 8V52H38V8Z" fill={color} opacity="0.85"/>
    <path d="M46 8L49 4L52 8V52H46V8Z" fill={color} opacity="0.8"/>
    {/* Wood grain lines */}
    <line x1="16" y1="20" x2="16" y2="40" stroke={color} strokeWidth="0.5" opacity="0.4"/>
    <line x1="24" y1="18" x2="24" y2="45" stroke={color} strokeWidth="0.5" opacity="0.4"/>
    <line x1="32" y1="22" x2="32" y2="42" stroke={color} strokeWidth="0.5" opacity="0.4"/>
    <line x1="40" y1="19" x2="40" y2="44" stroke={color} strokeWidth="0.5" opacity="0.4"/>
    <line x1="48" y1="21" x2="48" y2="43" stroke={color} strokeWidth="0.5" opacity="0.4"/>
  </svg>
);

// Chain Link Fence - diamond mesh pattern
export const ChainLinkIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" stroke={color} strokeWidth="1.5" className={className} {...props}>
    {/* Posts */}
    <rect x="2" y="4" width="5" height="56" fill={color} stroke="none"/>
    <rect x="57" y="4" width="5" height="56" fill={color} stroke="none"/>
    {/* Top rail */}
    <rect x="2" y="8" width="60" height="3" fill={color} stroke="none"/>
    {/* Diamond mesh pattern */}
    <path d="M10 12L18 20L10 28L18 36L10 44L18 52" fill="none"/>
    <path d="M18 12L26 20L18 28L26 36L18 44L26 52" fill="none"/>
    <path d="M26 12L34 20L26 28L34 36L26 44L34 52" fill="none"/>
    <path d="M34 12L42 20L34 28L42 36L34 44L42 52" fill="none"/>
    <path d="M42 12L50 20L42 28L50 36L42 44L50 52" fill="none"/>
    <path d="M50 12L54 16" fill="none"/>
    <path d="M50 28L54 32" fill="none"/>
    <path d="M50 44L54 48" fill="none"/>
    {/* Cross diamonds */}
    <path d="M10 20L18 12" fill="none"/>
    <path d="M18 20L26 12" fill="none"/>
    <path d="M26 20L34 12" fill="none"/>
    <path d="M34 20L42 12" fill="none"/>
    <path d="M42 20L50 12" fill="none"/>
    <path d="M10 36L18 28" fill="none"/>
    <path d="M18 36L26 28" fill="none"/>
    <path d="M26 36L34 28" fill="none"/>
    <path d="M34 36L42 28" fill="none"/>
    <path d="M42 36L50 28" fill="none"/>
    <path d="M10 52L18 44" fill="none"/>
    <path d="M18 52L26 44" fill="none"/>
    <path d="M26 52L34 44" fill="none"/>
    <path d="M34 52L42 44" fill="none"/>
    <path d="M42 52L50 44" fill="none"/>
    {/* Post caps */}
    <circle cx="4.5" cy="4" r="3" fill={color} stroke="none"/>
    <circle cx="59.5" cy="4" r="3" fill={color} stroke="none"/>
  </svg>
);

// Ornamental/Iron Fence - decorative spear tops
export const OrnamentalFenceIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Bottom rail */}
    <rect x="0" y="50" width="64" height="4" fill={color}/>
    {/* Middle rail */}
    <rect x="0" y="32" width="64" height="3" fill={color}/>
    {/* Vertical pickets with spear points */}
    <path d="M8 54V18L10 10L12 18V54H8Z" fill={color}/>
    <path d="M20 54V18L22 10L24 18V54H20Z" fill={color}/>
    <path d="M32 54V14L34 4L36 14V54H32Z" fill={color}/> {/* Taller center */}
    <path d="M44 54V18L46 10L48 18V54H44Z" fill={color}/>
    <path d="M56 54V18L58 10L60 18V54H56Z" fill={color}/>
    {/* Decorative circles/finials */}
    <circle cx="10" cy="8" r="2" fill={color}/>
    <circle cx="22" cy="8" r="2" fill={color}/>
    <circle cx="34" cy="3" r="2.5" fill={color}/>
    <circle cx="46" cy="8" r="2" fill={color}/>
    <circle cx="58" cy="8" r="2" fill={color}/>
    {/* Decorative scrollwork between pickets */}
    <path d="M12 40 Q16 36 20 40" stroke={color} strokeWidth="1.5" fill="none"/>
    <path d="M24 40 Q28 36 32 40" stroke={color} strokeWidth="1.5" fill="none"/>
    <path d="M36 40 Q40 36 44 40" stroke={color} strokeWidth="1.5" fill="none"/>
    <path d="M48 40 Q52 36 56 40" stroke={color} strokeWidth="1.5" fill="none"/>
  </svg>
);

// Picket Fence - classic white picket style
export const PicketFenceIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Horizontal rails */}
    <rect x="0" y="20" width="64" height="4" fill={color}/>
    <rect x="0" y="44" width="64" height="4" fill={color}/>
    {/* Pickets with pointed tops */}
    <path d="M4 52V12L8 4L12 12V52H4Z" fill={color}/>
    <path d="M16 52V12L20 4L24 12V52H16Z" fill={color}/>
    <path d="M28 52V12L32 4L36 12V52H28Z" fill={color}/>
    <path d="M40 52V12L44 4L48 12V52H40Z" fill={color}/>
    <path d="M52 52V12L56 4L60 12V52H52Z" fill={color}/>
  </svg>
);

// Ranch/Split Rail Fence
export const RanchFenceIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Left post with notches */}
    <rect x="2" y="8" width="8" height="48" fill={color}/>
    {/* Right post with notches */}
    <rect x="54" y="8" width="8" height="48" fill={color}/>
    {/* Rails going through posts */}
    <rect x="0" y="16" width="64" height="5" rx="2" fill={color} opacity="0.9"/>
    <rect x="0" y="32" width="64" height="5" rx="2" fill={color} opacity="0.9"/>
    <rect x="0" y="48" width="64" height="5" rx="2" fill={color} opacity="0.9"/>
    {/* Post tops rounded */}
    <ellipse cx="6" cy="8" rx="4" ry="2" fill={color}/>
    <ellipse cx="58" cy="8" rx="4" ry="2" fill={color}/>
  </svg>
);

// Fence Gate Icon
export const FenceGateIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Gate posts */}
    <rect x="2" y="4" width="8" height="56" fill={color}/>
    <rect x="54" y="4" width="8" height="56" fill={color}/>
    {/* Post caps */}
    <rect x="0" y="0" width="12" height="4" fill={color} rx="1"/>
    <rect x="52" y="0" width="12" height="4" fill={color} rx="1"/>
    {/* Left gate panel */}
    <rect x="12" y="12" width="18" height="44" stroke={color} strokeWidth="2" fill="none" rx="1"/>
    {/* Right gate panel */}
    <rect x="34" y="12" width="18" height="44" stroke={color} strokeWidth="2" fill="none" rx="1"/>
    {/* Gate cross braces */}
    <line x1="12" y1="12" x2="30" y2="56" stroke={color} strokeWidth="2"/>
    <line x1="30" y1="12" x2="12" y2="56" stroke={color} strokeWidth="2"/>
    <line x1="34" y1="12" x2="52" y2="56" stroke={color} strokeWidth="2"/>
    <line x1="52" y1="12" x2="34" y2="56" stroke={color} strokeWidth="2"/>
    {/* Gate hardware - hinges */}
    <rect x="10" y="20" width="4" height="6" fill={color}/>
    <rect x="10" y="42" width="4" height="6" fill={color}/>
    <rect x="50" y="20" width="4" height="6" fill={color}/>
    <rect x="50" y="42" width="4" height="6" fill={color}/>
    {/* Latch */}
    <circle cx="32" cy="34" r="3" fill={color}/>
  </svg>
);

// Fence Post Icon
export const FencePostIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Main post */}
    <rect x="20" y="8" width="24" height="52" fill={color} rx="2"/>
    {/* Post cap */}
    <path d="M16 8L32 0L48 8H16Z" fill={color}/>
    <rect x="16" y="6" width="32" height="4" fill={color}/>
    {/* Ground line */}
    <rect x="8" y="56" width="48" height="4" fill={color} opacity="0.5"/>
    {/* Concrete base indication */}
    <path d="M16 60L20 52H44L48 60H16Z" fill={color} opacity="0.3"/>
  </svg>
);

// Fence Hardware/Latch Icon  
export const FenceHardwareIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Latch plate */}
    <rect x="8" y="16" width="20" height="32" rx="2" fill={color}/>
    {/* Latch arm */}
    <rect x="24" y="28" width="28" height="8" rx="2" fill={color}/>
    {/* Latch catch */}
    <path d="M48 24V40L56 36V28L48 24Z" fill={color}/>
    {/* Screw holes */}
    <circle cx="14" cy="24" r="2" fill="white" opacity="0.5"/>
    <circle cx="14" cy="40" r="2" fill="white" opacity="0.5"/>
    <circle cx="22" cy="24" r="2" fill="white" opacity="0.5"/>
    <circle cx="22" cy="40" r="2" fill="white" opacity="0.5"/>
    {/* Handle */}
    <circle cx="36" cy="32" r="4" stroke={color} strokeWidth="2" fill="none"/>
  </svg>
);

// Fence Tools Icon (Post Hole Digger)
export const FenceToolsIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Handles */}
    <rect x="18" y="2" width="4" height="36" fill={color} rx="1"/>
    <rect x="42" y="2" width="4" height="36" fill={color} rx="1"/>
    {/* Handle grips */}
    <rect x="16" y="2" width="8" height="8" fill={color} rx="2"/>
    <rect x="40" y="2" width="8" height="8" fill={color} rx="2"/>
    {/* Digger blades */}
    <path d="M12 38C12 38 8 44 8 52C8 58 14 62 20 62C26 62 32 58 32 52C32 44 28 38 28 38H12Z" fill={color}/>
    <path d="M36 38C36 38 32 44 32 52C32 58 38 62 44 62C50 62 56 58 56 52C56 44 52 38 52 38H36Z" fill={color}/>
    {/* Pivot point */}
    <circle cx="32" cy="38" r="4" fill={color}/>
  </svg>
);

// Fence Delivery Truck
export const FenceDeliveryIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Truck bed */}
    <rect x="2" y="24" width="40" height="20" fill={color} opacity="0.8"/>
    {/* Truck cab */}
    <path d="M42 28H54C56 28 58 30 58 32V44H42V28Z" fill={color}/>
    {/* Windshield */}
    <rect x="46" y="30" width="8" height="8" fill="white" opacity="0.3" rx="1"/>
    {/* Wheels */}
    <circle cx="14" cy="48" r="6" fill={color}/>
    <circle cx="50" cy="48" r="6" fill={color}/>
    <circle cx="14" cy="48" r="3" fill="white" opacity="0.3"/>
    <circle cx="50" cy="48" r="3" fill="white" opacity="0.3"/>
    {/* Fence posts in truck bed */}
    <rect x="6" y="10" width="4" height="14" fill={color}/>
    <rect x="14" y="8" width="4" height="16" fill={color}/>
    <rect x="22" y="12" width="4" height="12" fill={color}/>
    <rect x="30" y="10" width="4" height="14" fill={color}/>
    {/* Ground line */}
    <rect x="0" y="54" width="64" height="2" fill={color} opacity="0.3"/>
  </svg>
);

// Fence Calculator
export const FenceCalculatorIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Calculator body */}
    <rect x="8" y="4" width="48" height="56" rx="4" fill={color}/>
    {/* Screen with fence diagram */}
    <rect x="12" y="8" width="40" height="16" rx="2" fill="white" opacity="0.9"/>
    {/* Mini fence in screen */}
    <rect x="16" y="12" width="2" height="10" fill={color} opacity="0.6"/>
    <rect x="22" y="14" width="2" height="8" fill={color} opacity="0.6"/>
    <rect x="28" y="14" width="2" height="8" fill={color} opacity="0.6"/>
    <rect x="34" y="14" width="2" height="8" fill={color} opacity="0.6"/>
    <rect x="40" y="14" width="2" height="8" fill={color} opacity="0.6"/>
    <rect x="46" y="12" width="2" height="10" fill={color} opacity="0.6"/>
    <rect x="16" y="16" width="32" height="2" fill={color} opacity="0.6"/>
    {/* Calculator buttons */}
    <rect x="12" y="28" width="10" height="8" rx="1" fill="white" opacity="0.3"/>
    <rect x="27" y="28" width="10" height="8" rx="1" fill="white" opacity="0.3"/>
    <rect x="42" y="28" width="10" height="8" rx="1" fill="white" opacity="0.3"/>
    <rect x="12" y="40" width="10" height="8" rx="1" fill="white" opacity="0.3"/>
    <rect x="27" y="40" width="10" height="8" rx="1" fill="white" opacity="0.3"/>
    <rect x="42" y="40" width="10" height="8" rx="1" fill="white" opacity="0.3"/>
    <rect x="12" y="52" width="25" height="6" rx="1" fill="white" opacity="0.5"/>
    <rect x="42" y="52" width="10" height="6" rx="1" fill="white" opacity="0.3"/>
  </svg>
);

// Privacy Fence (solid, no gaps)
export const PrivacyFenceIcon = ({ className = "w-6 h-6", color = "currentColor", ...props }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} {...props}>
    {/* Posts */}
    <rect x="2" y="4" width="8" height="56" fill={color}/>
    <rect x="54" y="4" width="8" height="56" fill={color}/>
    {/* Solid privacy panels */}
    <rect x="10" y="8" width="44" height="48" fill={color} opacity="0.85"/>
    {/* Horizontal shadow lines to show boards */}
    <line x1="10" y1="16" x2="54" y2="16" stroke={color} strokeWidth="1"/>
    <line x1="10" y1="24" x2="54" y2="24" stroke={color} strokeWidth="1"/>
    <line x1="10" y1="32" x2="54" y2="32" stroke={color} strokeWidth="1"/>
    <line x1="10" y1="40" x2="54" y2="40" stroke={color} strokeWidth="1"/>
    <line x1="10" y1="48" x2="54" y2="48" stroke={color} strokeWidth="1"/>
    {/* Post caps */}
    <rect x="0" y="0" width="12" height="4" fill={color} rx="1"/>
    <rect x="52" y="0" width="12" height="4" fill={color} rx="1"/>
  </svg>
);

export const FenceIcons = {
  Vinyl: VinylFenceIcon,
  Wood: WoodFenceIcon,
  ChainLink: ChainLinkIcon,
  Ornamental: OrnamentalFenceIcon,
  Picket: PicketFenceIcon,
  Ranch: RanchFenceIcon,
  Gate: FenceGateIcon,
  Post: FencePostIcon,
  Hardware: FenceHardwareIcon,
  Tools: FenceToolsIcon,
  Delivery: FenceDeliveryIcon,
  Calculator: FenceCalculatorIcon,
  Privacy: PrivacyFenceIcon,
};

export default FenceIcons;
